import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { DatePicker } from 'office-ui-fabric-react/lib/DatePicker';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { addDays } from 'office-ui-fabric-react/lib/utilities/dateMath/DateMath';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataProgramme } from '../../data/DataProgramme';
import { Immocom } from '../../specifique/immocom';
import { EUIDatePicker } from '../EUI/EUIDatePicker';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/****************************************************************
 PROPS:
    programme
    onPeutChargerLeComposant : bool (==false => on ne charge pas le composant ; ==true => on charge)

    onAffichePanelProgrammePlanning : bool

    onEnregistrementFiche : méthode
    onFermeFicheProgrammePlanning : méthode
    onChange : méthode appelée si onAffichageSansPanel = true
    
    classname : classe CSS (string)
    classnameinner : classe CSS (string)
****************************************************************/

var objetState = {
    programme: {},

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    onActiveBoutonEnregistrer: false,

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: ''
};

export class FicheProgrammePlanning extends Component {

    _creationContent() {
        let dateJour = new Date(Date.now());
        let dateLendemain = addDays(dateJour, 1);

        return (
            <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row lignePlanning">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xxxl6" />
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3">Date prévue</div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3">Date réelle</div>
                </div>
                <div className="ms-Grid-row lignePlanning">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xxxl6">Développement</div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" />
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateDeveloppement">
                        <EUIDatePicker
                            maxDate={dateJour}
                            onSelectDate={date => Scriba.state().setObjetPropriete(this, "programme", "dateDeveloppement", Scriba.date().getChaineISOFromDate(date), this._onValidationSurSortieDeChamp)}
                            placeholder="Date réelle"
                            value={this.state.programme.dateDeveloppement}
                        />
                    </div>
                </div>
                <div className="ms-Grid-row lignePlanning">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xxxl6">Montage</div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" />
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateMontage">
                        <EUIDatePicker
                            maxDate={dateJour}
                            onSelectDate={date => Scriba.state().setObjetPropriete(this, "programme", "dateMontage", Scriba.date().getChaineISOFromDate(date), this._onValidationSurSortieDeChamp)}
                            placeholder="Date réelle"
                            value={this.state.programme.dateMontage}
                        />
                    </div>
                </div>
                <div className="ms-Grid-row lignePlanning">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xxxl6">Accord comité promesse terrain</div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" />
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateAccordComitePromesse">
                        <EUIDatePicker
                            maxDate={dateJour}
                            onSelectDate={date => Scriba.state().setObjetPropriete(this, "programme", "dateAccordComitePromesse", Scriba.date().getChaineISOFromDate(date), this._onValidationSurSortieDeChamp)}
                            placeholder="Date réelle"
                            value={this.state.programme.dateAccordComitePromesse}
                        />
                    </div>
                </div>
                <div className="ms-Grid-row lignePlanning">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xxxl6">Sign. promesse terrain</div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateSignaturePromessePrevue">
                        <EUIDatePicker
                            minDate={dateLendemain}
                            onSelectDate={date => Scriba.state().setObjetPropriete(this, "programme", "dateSignaturePromessePrevue", Scriba.date().getChaineISOFromDate(date), this._onValidationSurSortieDeChamp)}
                            placeholder="Date prévue"
                            value={this.state.programme.dateSignaturePromessePrevue}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateSignaturePromesse">
                        <EUIDatePicker
                            maxDate={dateJour}
                            onSelectDate={date => Scriba.state().setObjetPropriete(this, "programme", "dateSignaturePromesse", Scriba.date().getChaineISOFromDate(date), this._onValidationSurSortieDeChamp)}
                            placeholder="Date réelle"
                            value={this.state.programme.dateSignaturePromesse}
                        />
                    </div>
                </div>
                <div className="ms-Grid-row lignePlanning">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xxxl6">Accord comité achat terrain</div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" />
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateAccordComiteAchatTerrain">
                        <EUIDatePicker
                            maxDate={dateJour}
                            onSelectDate={date => Scriba.state().setObjetPropriete(this, "programme", "dateAccordComiteAchatTerrain", Scriba.date().getChaineISOFromDate(date), this._onValidationSurSortieDeChamp)}
                            placeholder="Date réelle"
                            value={this.state.programme.dateAccordComiteAchatTerrain}
                        />
                    </div>
                </div>
                <div className="ms-Grid-row lignePlanning">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xxxl6">Achat terrain</div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateAchatTerrainPrevue">
                        <EUIDatePicker
                            minDate={dateLendemain}
                            onSelectDate={date => Scriba.state().setObjetPropriete(this, "programme", "dateAchatTerrainPrevue", Scriba.date().getChaineISOFromDate(date), this._onValidationSurSortieDeChamp)}
                            placeholder="Date prévue"
                            value={this.state.programme.dateAchatTerrainPrevue}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateAchatTerrain">
                        <EUIDatePicker
                            maxDate={dateJour}
                            onSelectDate={date => Scriba.state().setObjetPropriete(this, "programme", "dateAchatTerrain", Scriba.date().getChaineISOFromDate(date), this._onValidationSurSortieDeChamp)}
                            placeholder="Date réelle"
                            value={this.state.programme.dateAchatTerrain}
                        />
                    </div>
                </div>
                <div className="ms-Grid-row lignePlanning">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xxxl6">Fin de validité sign. promesse terrain</div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateSignaturePromesseFinValiditePrevue">
                        <EUIDatePicker
                            minDate={dateLendemain}
                            onSelectDate={date => Scriba.state().setObjetPropriete(this, "programme", "dateSignaturePromesseFinValiditePrevue", Scriba.date().getChaineISOFromDate(date), this._onValidationSurSortieDeChamp)}
                            placeholder="Date prévue"
                            value={this.state.programme.dateSignaturePromesseFinValiditePrevue}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateSignaturePromesseFinValidite">
                        <EUIDatePicker
                            onSelectDate={date => Scriba.state().setObjetPropriete(this, "programme", "dateSignaturePromesseFinValidite", Scriba.date().getChaineISOFromDate(date), this._onValidationSurSortieDeChamp)}
                            placeholder="Date réelle"
                            value={this.state.programme.dateSignaturePromesseFinValidite}
                        />
                    </div>
                </div>
            </div>
        );
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _onInit() {
        this.setState(objetState);
    }

    _chargementDonnees() {
        if (this.state.programme.idProgramme === undefined) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Chargement du programme en cours'
            });

            var chargementFicheProgrammePlanning = DataProgramme._chargementProgramme(this.props.programme.idProgramme, this.props.programme.idRegion, this.props.programme.idAgence);

            chargementFicheProgrammePlanning.then(
                responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let programmeTrav = responseFetch.reponseAPIobjet;

                        let stateTemp = {};
                        stateTemp.programme = programmeTrav;

                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
    }

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du planning du programme en cours'
        });

        const objet = {
            programme: this.state.programme
        }

        let onEnregistrementPlanningProgramme = DataProgramme._onEnregistrementProgramme(objet);

        onEnregistrementPlanningProgramme
            .then(responseFetch => {
                let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

                if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, { ...this.state }, this._onVerificationFormulaire);
                    this.props.onEnregistrementFiche();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onFermeFicheProgrammePlanning();
    }

    _onOpen = () => {
        this._chargementDonnees();
    }

    _onRenderFooterContent = () => {
        let boutonActif = this.state.onActiveBoutonEnregistrer;

        return (
            <div>
                <PrimaryButton name="btnEnregistrerProgrammePlanning" onClick={() => this._onEnregistrement()} className="marginRight8px" disabled={!boutonActif}>Enregistrer</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
            </div>
        );
    };

    _onMiseAJourChamp(nomObjet, nomPropriete, valeur) {
        Scriba.state().setObjetPropriete(this, nomObjet, nomPropriete, valeur, this._onVerificationFormulaire);
    }

    _onVerificationFormulaire() {
        Immocom.fiche()._validationFormulaire(this, 'DatesProgramme', this.state.programme, (this.state.programme.idProgramme > 0 ? 'Modification' : 'Création'));
    }
    _onValidationSurSortieDeChamp() {
        Immocom.fiche()._validationSurSortieDeChamp(this, 'DatesProgramme', this.state.programme, (this.state.programme.idProgramme > 0 ? 'Modification' : 'Création'));
    }

    render() {
        let content = this._creationContent();

        if (this.props.onAffichageSansPanel) {
            return content;
        }
        else {
            return (
                <Panel
                    isOpen={this.props.onAffichePanelProgrammePlanning}
                    headerText="Modifier le planning du programme"
                    type={PanelType.medium}
                    onDismiss={() => this._onAnnulation()}
                    onOpen={() => this._onOpen()}
                    closeButtonAriaLabel="Fermer"
                    onRenderFooterContent={this._onRenderFooterContent}
                >
                    <div className={this.props.classname}>
                        <div className={this.props.classnameinner}>
                            <div className="ms-Grid" dir="ltr">
                                <MessageBars
                                    errorMessage={this.state.errorMessage}
                                    warningMessage={this.state.warningMessage}
                                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                                />

                                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                                {content}
                            </div>
                        </div>
                    </div>
                </Panel>
            );
        }
    }
}